import { Step1WritingMetadata } from '../types/step1Writing';

export function createDefaultStep1WritingMetadata(
  migrationSource: Step1WritingMetadata['migrationSource']
): Step1WritingMetadata {
  const now = new Date().toISOString();
  return {
    pathSelected: false,
    hasContent: false,
    migratedAt: now,
    migrationSource,
    lastUpdated: now,
  };
}

/** Backfill pathSelected; clear implicit external default if the member never started. */
export function normalizeStep1WritingMetadata(
  metadata: Step1WritingMetadata
): Step1WritingMetadata {
  let meta = { ...metadata };

  if (meta.pathSelected === undefined) {
    meta.pathSelected = !!meta.mode;
  }

  const implicitExternalDefault =
    meta.mode === 'external' &&
    !meta.hasContent &&
    !meta.externalNote?.trim() &&
    (meta.migrationSource === 'legacy_v1_default_external' ||
      meta.migrationSource === 'new_user_default_external');

  if (implicitExternalDefault) {
    meta = {
      ...meta,
      pathSelected: false,
      mode: undefined,
      externalAcknowledged: undefined,
      migrationSource: 'new_user_choose_path',
    };
  }

  return meta;
}

export function migrateStep1WritingIfNeeded(
  savedData: Record<string, unknown> | null | undefined,
  isExistingUser: boolean
): { metadata: Step1WritingMetadata; applied: boolean } {
  if (savedData?.step1_writing && typeof savedData.step1_writing === 'object') {
    const normalized = normalizeStep1WritingMetadata(
      savedData.step1_writing as Step1WritingMetadata
    );
    const changed =
      JSON.stringify(normalized) !== JSON.stringify(savedData.step1_writing);
    return { metadata: normalized, applied: changed };
  }

  const migrationSource = isExistingUser
    ? 'legacy_v1_default_external'
    : 'new_user_choose_path';

  return {
    metadata: createDefaultStep1WritingMetadata(migrationSource),
    applied: true,
  };
}
